import UserResetPassword from './UserResetPassword';

export default UserResetPassword;